import { get, postJSON, del, post } from '../utils/axios'

// 施工足迹头部设备信息
export const getFootprintFacilityVO = (facilityPk: string) => post('/yme-facility/sgFootprint/getFootprintFacilityVO', { facilityPk })

// 施工足迹列表信息
interface optionsProps {
    page?: string | number //当前页
    size?: string | number //每页大小
    createStartTime?: string //创建开始时间 年月日
    createEndTime?: string //开始结束时间 年月日
    footprintStartTime?: string //足迹开始时间
    footprintEndTime?: string //足迹结束时间
    facilityTypePk?: string //设备类型PK
    facilityPk: string //设备PK
    searchName?: string //组合搜索-根据设备id,商户名称,门店名称搜索
}
export const getFootprintList = (options: optionsProps) => postJSON('/yme-facility/sgFootprint/getFootprintList', options)

// 施工足迹-日历的数量
export const getFootprintCalendar = (options: optionsProps) => postJSON('/yme-facility/sgFootprint/getFootprintCalendar', options)

// 根据施工单PK查询施工足迹
interface getFootprintListBySgPkProps {
    facilityPk?: string
    sgPk?: string
    footprintStartTime?: string
    footprintEndTime?: string
}
export const getFootprintListBySgPk = (options:getFootprintListBySgPkProps ) => post('/yme-facility/sgFootprint/getFootprintListBySgPk', options)

//施工足迹-施工单pk查询施工报告详情
interface billPkProps {
    constructionBillPk: string //施工单pk
    orgPk: string //门店pk
}
export const getSelectReportDetailByConstructionBillPk = (options: billPkProps) => post('constructionReport/selectReportDetailByConstructionBillPk', options)

// IoT-运营报表-设备趋势图
interface iotReportSbTrendChartProps {
    createStartTime?: string //创建开始时间 年月日
    createEndTime?: string //开始结束时间 年月日
    facilityTypePk?: string //设备类型PK
    facilityCode?: string //设备类型code-代码
}
export const getIotReportSbTrendChart = (options: iotReportSbTrendChartProps) => postJSON('/yme-facility/iotReport/getIotReportSbTrendChart', options)

//IoT-运营报表-施工趋势图
export const getIotReportSgTrendChart = (options: iotReportSbTrendChartProps) => postJSON('/yme-facility/iotReport/getIotReportSgTrendChart', options)


